import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createVNode as _createVNode, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-33c43955")

_pushScopeId("data-v-33c43955")
const _hoisted_1 = { class: "ui__infoList_main" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (_openBlock(true), _createBlock(_Fragment, null, _renderList($setup.state.dataList, (item) => {
      return (_openBlock(), _createBlock("div", {
        class: ["ui_infoList_item", {direction:$props.direction}],
        key: item.name
      }, [
        _createVNode("div", {
          class: "ui_infoList_item_label",
          style: {width: $props.labelWidth}
        }, _toDisplayString(item.fieldName), 5),
        _createVNode("div", {
          class: "ui_infoList_item_value",
          style: {width: $props.valueWidth}
        }, [
          (item.fieldValue)
            ? (_openBlock(), _createBlock("span", _hoisted_2, _toDisplayString(item.fieldValue), 1))
            : (_openBlock(), _createBlock("span", _hoisted_3, "-"))
        ], 4)
      ], 2))
    }), 128))
  ]))
})